import { CompanyDetails } from '@/types/companies';
import { SVSummaryCard } from '../core';
import { SVSummaryCardItem } from '@/types/common';
import { formatDateTimeFromUTC } from '@/utils/date';
import StatusLabel from '../StatusLabel';
import { titleCase } from '@/utils/stringCaser';

type CompanyDetailsInfoProps = {
  companyDetails: CompanyDetails;
};

export default function CompanyDetailsInfo({
  companyDetails,
}: CompanyDetailsInfoProps) {
  const {
    name,
    advisorOfficeType,
    relationshipManager,
    companyUrl,
    status,
    createdAt,
    lendingEnabled,
  } = companyDetails;

  const items: SVSummaryCardItem[] = [
    {
      label: 'Name',
      text: name,
    },
    {
      label: 'Advisor Office Type',
      text: advisorOfficeType === 0 ? 'Independent' : 'Corporate',
    },
    {
      label: 'Status',
      customContent: <StatusLabel status={status} />,
    },
    {
      label: 'Relationship Manager',
      text: relationshipManager
        ? `${relationshipManager.name} (${relationshipManager.email})`
        : 'N/A',
    },
    {
      label: 'Company URL',
      text: companyUrl || 'N/A',
    },
    {
      label: 'Created Date',
      text: formatDateTimeFromUTC(createdAt),
    },
    {
      label: 'Lending Enabled',
      text: titleCase(`${lendingEnabled}`),
    },
  ];

  return <SVSummaryCard label="Basic Info" items={items} />;
}
